import React from 'react'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { IconDetails } from '../../../../../../shared/icon/icon'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { Card } from '../../../../../../shared/card/card'
import { useApiFormSaveSnapshot } from '../../../../../../api-new/state/content'
import { useParams } from 'react-router-dom'
import { FormSimple } from '../../../../../../shared/form-simple/form'
import { FormSimpleText } from '../../../../../../shared/form-simple/form-text'
import { FormSimpleJsonEditor } from '../../../../../../shared/form-simple/form-json-editor'
import { FormSimpleSubmitEdit } from '../../../../../../shared/form-simple/form-submit'

export const NodeSaveSnapshotEdit = ({ parentURL }) => {
  const { id } = useParams()

  const apiFormSaveSnapshot = useApiFormSaveSnapshot()

  const handleMatch = () => apiFormSaveSnapshot.get(id)
  const handleSubmit = data => apiFormSaveSnapshot.put(data.id, data)

  return (
    <BreadcrumbView Icon={IconDetails} text="Edit snapshot" onMatch={handleMatch}>
      <CardFullHeightScrollY>
        <Card title="edit snapshot">
          <FormSimple state={apiFormSaveSnapshot.form} onSubmit={handleSubmit}>
            <FormSimpleText name="email" readonly />
            <FormSimpleText name="savedAt" readonly />
            <FormSimpleText name="name" />
            <FormSimpleJsonEditor name="items" />
            <FormSimpleSubmitEdit backURL={parentURL} />
          </FormSimple>
        </Card>
      </CardFullHeightScrollY>
    </BreadcrumbView>
  )
}
